module.exports = __webpack_public_path__ + "static/img/zhawlogol.3052439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhawlogol.png
// module id = +uRe
// module chunks = 1